import CircularProgress, { type CircularProgressProps } from '@mui/material/CircularProgress';

export type LoaderProps = Omit<CircularProgressProps, 'size'> & {
  size?: 'large' | 'medium';
};

export function Loader({ size = 'large', ...props }: LoaderProps) {
  return <CircularProgress size={size === 'large' ? 64 : 32} {...props} />;
}
